import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sizePage } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class CaeUserService {
  /**
   * Realiza un POST a http://192.168.0.86:8989/identitum-api/person
   * @param data Datos a enviar en el body
   */
  postPersonIdentitum(data: any): Observable<any> {
    const url = '/identitum-api/person';
    return this.http.post<any>(url, data, { observe: 'response' });
  }

  constructor(private readonly http: HttpClient) { }

  CreateCaeUser(pData: any): Observable<any> {
    return this.http.post<any>('/identitum-api/person',
      pData, { observe: 'response' });
  }

  UpdateUserCae(pData: any): Observable<any> {
    return this.http.put<any>('/identitum-api/person',
      pData, { observe: 'response' });
  }

  GetUserCaeList(pData: string, page: number): Observable<any> {
    page--;
    let urlGetList = `/identitum-api/person/all?size=10&page=${page}`;
    if (pData && pData.length > 0) {
      urlGetList = `/identitum-api/person/all?${pData}&size=10&page=${page}`;
    }
    return this.http.get<any>(urlGetList, { observe: 'response' });
  }

  GetUserCae(pData: string): Observable<any> {
    let url = '/identitum-api/person/' + pData;
    return this.http.get<any>(url, { observe: 'response' });
  }


  DeleteUserCae(pData: any[]): Observable<any> {
    let url = '/identitum-api/person/delete';
    return this.http.put<any>(url, pData, { observe: 'response' });
  }


  GetUserCaeLocation(pData: string): Observable<any> {
    let url = '/assistance/location/self/reference/all?id=' + pData;
    return this.http.get<any>(url, { observe: 'response' });
  }


  UpdateUserCaeLocation(id: string, pData: any): Observable<any> {
    let url = '/assistance/location/self';
    return this.http.put<any>(url, pData, { observe: 'response' });
  }

  GetUserCaeGroup(pData: string): Observable<any> {
    let url = '/assistance/group/membership/all/person?id=' + pData;
    return this.http.get<any>(url, { observe: 'response' });
  }

  GetReport(pData: string, page: number): Observable<any> {
    page--;
    let parameters = pData + '&page=' + page +
      "&sort=creationDate::desc&size=10";
    let url = '/assistance/person/report/person/all?';
    let urlGetList = url + parameters;
    return this.http.get<any>(urlGetList, { observe: 'response' });
  }

  GetReportSync(pData: string): Observable<any> {
    let urlGetList = "/assistance/person/history/failed-persons/last/" + pData;
    return this.http.get<any>(urlGetList, { observe: 'response' });
  }


  GetFileTemplate(pData: string): Observable<any> {
    let url = "/identitum-api/bulk";
    return this.http.get<any>(url, { observe: 'response' });
  }


  SyncUsers(pcompanyId: string, puserId: string): Observable<any> {
    let url = "/assistance/sync/person?companyId=" + pcompanyId + "&userId=" + puserId;
    console.info(url);
    return this.http.get<any>(url, { observe: 'response' });
  }

  InsertReportItem(pcompanyId: string, puserId: string, description: string): Observable<any> {
    let url = "/binnacle/sync?type=SP&companyId=" + pcompanyId + "&userId=" + puserId + "&startDate=" + Date.now() + "&description=" + description;
    console.info(url);
    return this.http.post<any>(url, { observe: 'response' });
  }

  /*
  Servicio listado de historial de carga masiva
  */
  GetUserCaeHistoryList(pData: string, page: number): Observable<any> {
    page--;
    ///assistance/person/history/page/0?size=5&jobId=
    let url = '/assistance/person/history/';
    let urlGetList = `${url}page/${page}?size=10&${pData}`;
    console.info(urlGetList);
    return this.http.get<any>(urlGetList, { observe: 'response' });
  }


  GetReportByJobId(pData: string): Observable<any> {
    let url = '/assistance/person/history/failed-persons/';
    let urlGetList = url + pData;
    return this.http.get<any>(urlGetList, { observe: 'response' });
  }

  BulkUsers(pData: any): Observable<any> {
    console.info("BulkUsers");
    console.info(pData);
    ///assistance/person/batch/upload?companyId={}&branchId={}&userId={}
    let url = '/identitum-api/bulk';
    console.info(url);
    return this.http.post<any>(url, pData, { observe: 'response' });
  }


}
